// Central query-key factory so invalidation stays consistent across modules.
export const qk = {
  me: ['me'] as const,
  org: ['org'] as const,
  team: ['org', 'team'] as const,
  brand: ['org', 'brand'] as const,
  overlays: ['overlays'] as const,
  apiKeys: ['me', 'api-keys'] as const,

  screens: (filters?: unknown) => ['screens', filters ?? null] as const,
  screen: (id: string) => ['screens', id] as const,
  screenPreview: (id: string) => ['screens', id, 'preview'] as const,

  groups: ['groups'] as const,
  layouts: ['layouts'] as const,

  media: (filters?: unknown) => ['media', filters ?? null] as const,
  mediaItem: (id: string) => ['media', id] as const,

  playlists: ['playlists'] as const,
  playlist: (id: string) => ['playlists', id] as const,

  schedules: (filters?: unknown) => ['schedules', filters ?? null] as const,
  schedule: (id: string) => ['schedules', id] as const,
  schedulePreview: (screenId: string, at?: number) =>
    ['schedules', 'preview', screenId, at ?? 'now'] as const,

  adminOrgs: ['admin', 'orgs'] as const,

  attention: ['attention'] as const,

  // Sprint 8 — analytics + live snapshots + scheduled reports.
  analyticsPlayback: (params?: unknown) => ['analytics', 'playback', params ?? null] as const,
  analyticsUptime: (params?: unknown) => ['analytics', 'uptime', params ?? null] as const,
  snapshots: (screenId: string) => ['screens', screenId, 'snapshots'] as const,
  reportSchedules: ['report-schedules'] as const,

  // Sprint 10 — instant broadcast + activity (audit) log.
  broadcastCurrent: ['broadcast', 'current'] as const,
  audit: (filters?: unknown) => ['audit', filters ?? null] as const,
};
